import { Accordion, InputField, ToggleField, NumberField } from '@ubeya/shared-web/components';
import React, { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { useField } from 'react-final-form';
import { FieldsContainer, SectionContent } from '../styled';

const Tax = () => {
  const { t } = useContext(ConfigContext);

  const {
    input: { value: vat }
  } = useField('invoicing.vat');

  const enabled = !!vat;

  return (
    <Accordion defaultOpenRows={{ 0: true }}>
      <Accordion.Item title={t('invoicingSettings__tax')}>
        <SectionContent>
          <ToggleField name="invoicing.vat" text={t('invoicingSettings__enableVat')} />
          {enabled && (
            <FieldsContainer $count={3}>
              {/*<InputField*/}
              {/*  name="invoicing.vatNumber"*/}
              {/*  title={t('invoicingSettings__vatNumber')}*/}
              {/*  required*/}
              {/*  validate={required}*/}
              {/*/>*/}
              <InputField
                name="invoicing.vatUniqueTaxReference"
                title={t('invoicingSettings__vatUniqueTaxReference')}
              />
              <NumberField name="invoicing.vatPercentage" title={t('invoicingSettings__vatPercentage')} />
            </FieldsContainer>
          )}
        </SectionContent>
      </Accordion.Item>
    </Accordion>
  );
};

export default Tax;
